<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Cash Transfer" disabled placeholder="Cash Transfer" single-line solo hide-details
                    readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field min="1" v-model="depositAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line solo hide-details
                    class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="needSlip == 1">
                <div class="input-file">
                  <span>Upload Pay.Proof</span>
                  <v-file-input v-model="bankSlip" label="Choose file" filled prepend-icon="mdi-file-image"
                    hide-details></v-file-input>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-btn  @click.prevent="handleSubmit" tile elevation="0" type="submit" class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain" :loading="loading" :disabled="loading">
                  Deposit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card mt-2"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }} <p class="icon-badge" v-if="selectedAccountDetails.is_trade_master == 1">TRADEMASTER</p> </span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>
            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>

          <v-card v-if="selectedAccountDetails?.is_trade_master == 1" class="elevation-0 rounded-0 deposit-form-card mt-2 mb-5" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="value-trades">
                <p>Investment Rule</p>
              </div>
            </v-card-actions>
            <v-card-actions>
                <span class="rules-info">
                  <p class="color-white">1.First Deposit:</p>
                  <li>The first deposit must be $1,000 plus an annual fee of $110.</li>
                  <li>Total First Deposit = $1,110</li>
                </span>
            </v-card-actions>
             
            <v-card-actions>
                <span class="rules-info mt-3">
                  <p class="color-white">2.Subsequent Deposits:</p>
                  <li>Any additional deposit must be a multiple of $500.</li>
                  <li>Allowed amounts: $500, $1,000, $1,500, $2,000, etc.</li>
                  <li>Not allowed: $600, $750, $1,250, etc.</li>
                </span>
            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,
      selectedAccount: null,
      depositAmount: '',
      currencyAmount: '',
      bankSlip: null,
      loading: false,
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#fff"
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
    };
  },

  computed: {
    ...mapState("deposit", ["accounts","needSlip"]),
    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },
    selectedAccountDetails() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
    },
  },

  watch: {
    depositAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.CREATECASHDEPOSIT,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
    ]),

    handleAccountChange() {
      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      
      this.depositAmount = '';
      this.currencyAmount = ''; 

      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        const amount = parseFloat(this.depositAmount);
        if (isNaN(amount) || amount <= 0) {
          this.loading = false;
          return toast.error('Please enter a valid deposit amount');
        }
        const formData = new FormData();
        formData.append('trading_account_no', this.selectedAccount);
        formData.append('amount', this.depositAmount);
        formData.append('payment_slip', this.bankSlip);
        formData.append('payment_id', this.payment_id);

        await this[DEPOSITMETHODS__ACTIONS.CREATECASHDEPOSIT](formData);

        this.resetForm();

      } catch (error) {
        console.error('Deposit submission error:', error?.message || error);
      } finally {
        this.loading = false;
      }
    },


    resetForm() {
      this.selectedAccount = null;
      this.depositAmount = '';
      this.bankSlip = null;
    }
  },
  async created() {
    this.payment_id = this.$route.query.payment_id;
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();
  },
};
</script>

<style>
.rules-info{
  opacity: 0.5;
  font-size: 13px;
}
</style>
